export enum PrintibleActions {
  CLOSE_PRINTIBLE_WINDOW = 'closePrintibleWindow',
  PRINTIBLE_CREATED = 'printibleCreated',
  NOT_SET = 'notSet',
}
